export class LoginCommand {
    constructor(public userName: string,
                public password: string) {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/auth/login.command.ts